/* eslint-disable import/prefer-default-export */
import {SectionModelV1} from 'resources/GeneratedModels/Section/SectionModel.v1';

import {sectionExtensions} from './section.extensions';
import sectionValidators from './section.validators';

SectionModelV1.extend(sectionExtensions);
SectionModelV1.addValidators(sectionValidators);

export {SectionModelV1};
